import api, { HEADERS } from '~config/api';
import OrderService from '~services/Order/service';
import PollingService from '~services/PollingService';

export const DeliveryService = {
  getDeliveryEstimate: ({ storeId, orderId, type }) => {
    api.setHeader(HEADERS.ADMIN_STORE_ID, storeId);

    return PollingService.poll(
      api.post(`v1/kds/store/${storeId}/orders/${orderId}/deliveries/estimate`, {
        delivery: { type: type }
      }),
      OrderService.checkOrder
    );
  },
  setNewDelivery: ({ storeId, orderId, type }) => {
    api.setHeader(HEADERS.ADMIN_STORE_ID, storeId);

    return PollingService.poll(
      api.post(`v1/kds/store/${storeId}/orders/${orderId}/deliveries/`, {
        delivery: { type: type }
      }),
      OrderService.checkOrder
    );
  },
  cancelDelivery: ({ deliveryId, values }) => {
    return api.post(`v1/kds/deliveries/${deliveryId}/cancel`, {
      delivery: {
        reason: values.notes
      }
    });
  }
};

export default DeliveryService;
